<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeContractManage.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="handleAdd">
              <i class="el-icon-plus"></i>{{ $t('committeeContractManage.action.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.keyword" :placeholder="$t('committeeContractManage.search.keywordPlaceholder')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="id" :label="$t('committeeContractManage.table.id')" min-width="62" show-overflow-tooltip />
          <el-table-column prop="contractName" :label="$t('committeeContractManage.table.contractName')" min-width="150" show-overflow-tooltip />
          <el-table-column prop="contractType" :label="$t('committeeContractManage.table.contractType')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="partyA" :label="$t('committeeContractManage.table.partyA')" min-width="120" show-overflow-tooltip />
          <el-table-column prop="partyB" :label="$t('committeeContractManage.table.partyB')" min-width="120" show-overflow-tooltip />
          <el-table-column prop="startTime" :label="$t('committeeContractManage.table.startTime')" min-width="150" show-overflow-tooltip />
          <el-table-column prop="endTime" :label="$t('committeeContractManage.table.endTime')" min-width="150" show-overflow-tooltip />
          <el-table-column prop="contractAmount" :label="$t('committeeContractManage.table.contractAmount')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="state" :label="$t('committeeContractManage.table.state')" min-width="80" show-overflow-tooltip />
          <el-table-column prop="createTime" :label="$t('committeeContractManage.table.createTime')" min-width="150" show-overflow-tooltip />
          <el-table-column :label="$t('committeeContractManage.table.action')" min-width="160" align="center">
            <template slot-scope="scope">
              <div class="action-links">
                <el-button type="text" size="small" @click="handleDetail(scope.row)">{{ $t('committeeContractManage.action.detail') }}</el-button>
                <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('committeeContractManage.action.edit') }}</el-button>
                <el-button type="text" size="small" class="delete-btn" @click="handleDelete(scope.row)">{{ $t('committeeContractManage.action.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="pagination.total" :current-page="pagination.page" :page-size="pagination.row" :page-sizes="[10, 20, 50]" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { queryContract, updateContract, deleteContract, uploadContactFile } from '@/api/contract/contractManageApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'

export default {
  name: 'CommitteeContractManageList',
  data() {
    return {
      loading: false,
      conditions: { keyword: '' },
      tableData: [],
      pagination: { total: 0, page: 1, row: 10 },
      communityList: []
    }
  },
  created() { this.loadCommunities(); this.getList() },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 400, fontSize: '14px' } },
    cellStyle() { return { fontSize: '14px' } },
    isSuccess(res) { return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success') },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      if (Array.isArray(res && res.rows)) return res.rows
      return []
    },
    getTotal(res, list) { return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0) },
    async getList() {
      try {
        this.loading = true
        const res = await queryContract({ page: this.pagination.page, row: this.pagination.row, keyword: this.conditions.keyword, communityId: getCommunityId() })
        const list = this.getListArray(res)
        this.tableData = list
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error('获取合同列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleAdd() { /* TODO */ },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.communityList = res.data || []
      } catch (e) {
        this.communityList = []
      }
    },
    handleEdit(row) { /* TODO */ },
    handleDetail(row) { /* TODO */ },
    handleDelete(row) {
      this.$confirm(this.$t('committeeContractManage.dialog.deleteConfirm'), this.$t('committeeContractManage.dialog.deleteTitle'), { type: 'warning' }).then(() => {
        this.$message.success(this.$t('committeeContractManage.dialog.deleteSuccess'))
        this.getList()
      }).catch(() => {})
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.admin-room-container { padding: 20px; height: 100%; box-sizing: border-box; }
.figma-white-card { background: white; border-radius: 12px; padding: 20px 24px; height: 100%; display: flex; flex-direction: column; }
.figma-page-header { flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; margin-bottom: 12px; }
.figma-header-divider { height: 1px; background: #EBF2FA; margin-bottom: 12px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.figma-btn-group { display: flex; gap: 8px; }
.figma-btn-add { background: #0E76FF !important; border-color: #0E76FF !important; color: white !important; border-radius: 10px !important; }
.figma-btn-refresh { background: white !important; border-color: #DCE6F5 !important; color: #364153 !important; border-radius: 10px !important; }
.figma-search-group { display: flex; gap: 8px; align-items: center; }
.figma-search-input { width: 256px; }
.figma-btn-search { background: white !important; border-color: #0E76FF !important; color: #0E76FF !important; border-radius: 10px !important; }
.figma-table-section { flex: 1; margin-top: 12px; overflow: auto; }
.figma-pagination-section { display: flex; justify-content: flex-end; padding-top: 16px; flex-shrink: 0; }
.action-links { display: flex; align-items: center; justify-content: center; gap: 8px; }
.delete-btn { color: #F56C6C !important; }
</style>
